import { useState } from "react";
import { Button, Stack, Col, Row } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import TagSelector, { Tag, getSelectedOptions } from "../ReactSelect";
import { MultiValue, SingleValue } from "react-select";
import { TrashGridType } from "../../class/frontend.schema";
import { useI18n } from "../../i18n";

type TrashGridControlProps = {
  onRestoreClick: () => void;
  onDeleteClick?: () => void;
  recordType: string;
  setRecordTypeFunc: (value: TrashGridType) => void;
  disabled: boolean;
};

const TrashGridControl = ({
  onRestoreClick,
  onDeleteClick,
  recordType,
  setRecordTypeFunc,
  disabled,
}: TrashGridControlProps) => {
  const { t } = useI18n();
  const options = [
    {
      value: "record",
      label: t("nav.record"),
    },
    {
      value: "calendar",
      label: t("nav.calendar"),
    },
    {
      value: "place",
      label: t("nav.place"),
    },
  ];

  const [type, setType] = useState<string>(recordType);

  return (
    <div style={{ float: "right" }}>
      <Stack gap={2} direction="horizontal">
        <div style={{ minWidth: "200px" }}>
          <TagSelector
            isMulti={false}
            options={options as Tag[]}
            defaultValue={getSelectedOptions(options, type)}
            onChange={(event: MultiValue<any> | SingleValue<any>) => {
              if (!event) {
                return;
              }
              setType(event.value);
              setRecordTypeFunc(event.value);
            }}
            placeholder="Record Type"
          />
        </div>

        <Stack direction="horizontal" gap={2} style={{ float: "right" }}>
          <Button
            style={{ maxWidth: "200px", float: "right" }}
            variant="secondary"
            className="mr-3"
            onClick={onRestoreClick}
            disabled={disabled}
          >
            {" "}
            <MdRestore className="d-inline mr-1  mb-1" />
            {t("common.restore")}
          </Button>
          <Button
            style={{ maxWidth: "200px", float: "right" }}
            variant="danger"
            className="mr-2"
            onClick={onDeleteClick}
            disabled={disabled}
          >
            {" "}
            <FaTrashAlt className="d-inline mr-1  mb-1" />
            {t("common.delete")}
          </Button>
        </Stack>
      </Stack>
    </div>
  );
};

export default TrashGridControl;
